const ENDPOINTS = {
  get: (params = '') => `locks/?${params}`,
  getOneLock: (id = '', params = '') => `locks/${id}?${params}`,
  unlock: (params = '') => `locks/unlock/?${params}`,
  getOneUnlockLink: (id = '', params = '') => `unlock-links/${id}?${params}`,
};

export {ENDPOINTS};
